export class MyClientsReSingRespondeModel {
    contrato: number;
    cupo_comprador: number;
    documento: number;
    estado: string;
    fecha_apertura: string;
    fecha_radicacion: string;
    fecha_solicitud: string;
    formulario: boolean;
    id_unico: number;
    medio: string;
    nombre: string;
    radicacion: number;
    tipo_documento: string;
    id_tx: string;
    habilitarPagareToogle: boolean
}